import { TYPE_STRING } from './input-types';

export const id = 'orderNumber';
export const apiKey = 'OrderNumber';
export const type = TYPE_STRING;

export const orderNumber = {
  id,
  apiKey,
  type,
};
